import React from 'react';
import {
  FooterContainer,
  Quote,
  QuoteFooter
} from '../app';

const Footer = () => {
  return (
    <FooterContainer>
      <Quote>
        "Most of us spend too much time on what is urgent, and not enough time on what is important."
        <QuoteFooter>Stephen Covey<br />The 7 Habits of Highly Effective People</QuoteFooter>
      </Quote>
    </FooterContainer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js